module.exports = __webpack_public_path__ + "img/014任若凡.b1b61cc4.png";